import React from "react";
// import { CheckSquare } from 'feather-icons-react';
import { Container, Col, Row, Card, Button, Alert } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import SplitNumber from "../../../_Components/SplitNumber";
import {
  IconCheckCircle,
  IconErrorCircle,
} from "../../../../../_metronic/css/icons";
import classNames from "classnames";
function MessageBox(props) {
  const location = useLocation();
  console.log("props", props);

  return (
    <>
      <Container className="my-auto text-center" style={{ maxWidth: "500px" }}>
        <Card className="rounded-5 ">
          <Card.Header
            className={classNames(
              "rounded-top-5 ",
              props.resultType === "success"
                ? "bg-dark-success"
                : "bg-light-danger"
            )}
          >
            <div className=" d-flex justify-content-center large-icons">
              {props.resultType === "success" ? (
                <IconCheckCircle fill="#09a463" width="90px" />
              ) : (
                <IconErrorCircle fill="red" width="90px" />
              )}
            </div>
            <div
              className={classNames(
                " text-center py-2 mt-3  fs-large fw-bold",
                props.resultType === "success" ? "text-green" : "text-danger"
              )}
            >
              {props.titleBox}
            </div>
            <div
              className={classNames(
                "fw-bold",
                props.resultType === "success" ? "text-green" : "text-danger"
              )}
            >
              {props.descTitleBox}
            </div>
          </Card.Header>
          <Card.Body>
            {props.boxType === 4 && (
              ////////////////////////////// سبد پرداخت شد و کیف پولش به اندازه کافی موجودی داشت
              <div className=" pt-2  pb-5 mb-5 fs-medium">
                شما اکنون مبلغ
                <span className=" fw-bold"> {" "}
                  <SplitNumber number={props.amount} ></SplitNumber> تومان {" "}
                </span>{" "}
                پرداخت کرده اید و به کیف پول شما اضافه شد.
              </div>
            )}
            {props.boxType === 5 && (
              <div className=" pt-2  pb-5 mb-5 fs-medium">
                مشکلی پیش امده لطفا با پشتیبانی تماس بگیرید.
              </div>
            )}
            {props.boxType === 3 && (
              <div className=" pt-2  pb-5 mb-5 fs-medium">
                {props.errorText}
              </div>
            )}
            {props.amount && (
              <Row className=" fs-medium py-3">
                <Col xs="auto"> مبلغ پرداختی</Col>
                <Col className="my-auto opacity-10 px-0">
                  <div
                    style={{
                      borderTop: "1px dashed #000",
                      height: "1px",
                    }}
                  ></div>
                </Col>
                <Col xs="auto" className="fw-bold">
                  <SplitNumber number={props.amount}></SplitNumber> تومان{" "}
                </Col>
              </Row>
            )}

            {props.referenceId && (
              <Row className=" fs-medium py-3">
                <Col xs="auto">شماره پیگیری</Col>
                <Col className="my-auto opacity-10 px-0">
                  <div
                    style={{
                      borderTop: "1px dashed #000",
                      height: "1px",
                    }}
                  ></div>
                </Col>
                <Col xs="auto" className="fw-bold">
                  {props.referenceId}
                </Col>
              </Row>
            )}

            {props.userWalletRiallBalance && (
              <Row className=" fs-medium py-3">
                <Col xs="auto"> موجودی کیف پول </Col>
                <Col className="my-auto opacity-10 px-0">
                  <div
                    style={{
                      borderTop: "1px dashed #000",
                      height: "1px",
                    }}
                  ></div>
                </Col>
                <Col xs="auto" className="fw-bold">
                  <SplitNumber
                    number={props.userWalletRiallBalance}
                  ></SplitNumber>{" "}
                  تومان{" "}
                </Col>
              </Row>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}

export default MessageBox;
